import * as claimsActionTypes from "store/actions/input/claims/claimsActionTypes";
import * as persistenceActionTypes from "store/actions/persistence/persistenceActionTypes";

export const INIT_STATE = {
  chartZoom: {},
  claimsFileColumnMappingDisplay: {
    claimsKey: null,
    state: "IDLE",
    data: {},
  },
};

const tempClaimsReducer = (state, action) => {
  if (state === undefined) {
    state = INIT_STATE;
  }

  switch (action.type) {
    case persistenceActionTypes.LOAD_SUBMISSION_STARTED:
      return {
        ...INIT_STATE,
      };
    case claimsActionTypes.CLAIMS_FILE_COLUMN_MAPPING_DISPLAY_LOADED:
      if (
        action.payload["claims-key"] !==
        state.claimsFileColumnMappingDisplay.claimsKey
      )
        return state;
      return {
        ...state,
        claimsFileColumnMappingDisplay: {
          ...state.claimsFileColumnMappingDisplay,
          state: "LOADED",
          data: action.payload,
        },
      };
    case claimsActionTypes.SHOW_CLAIMS_FILE_COLUMN_MAPPING_DISPLAY:
      return {
        ...state,
        claimsFileColumnMappingDisplay: {
          claimsKey: action.payload,
          state: "LOADING",
          data: {},
        },
      };
    case claimsActionTypes.CLAIMS_FILE_COLUMN_MAPPING_DISPLAY_LOAD_FAILED:
      return {
        ...state,
        claimsFileColumnMappingDisplay: {
          ...state.claimsFileColumnMappingDisplay,
          state: "FAILED",
        },
      };
    case claimsActionTypes.HIDE_CLAIMS_FILE_COLUMN_MAPPING_DISPLAY:
      return {
        ...state,
        claimsFileColumnMappingDisplay: {
          claimsKey: null,
          state: "IDLE",
          data: {},
        },
      };
    case claimsActionTypes.UPDATE_CLAIMS_ZOOM:
      return {
        ...state,
        chartZoom: {
          ...state?.chartZoom,
          [action.payload.name]: action.payload.zoom,
        },
      };
    case claimsActionTypes.CLEAR_CHART_ZOOM:
      return {
        ...state,
        chartZoom: {
          ...state?.chartZoom,
          [action.payload]: undefined,
        },
      };
    default:
      return state;
  }
};

export default tempClaimsReducer;
